// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import store from './assets/js/stateStore'
import dateFormate from './assets/js/dateUtil'
Date.prototype.format=dateFormate;
import router from "./assets/js/route"
import permission from "./assets/js/permission"
import echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map';
import "./assets/css/jjld.css"
import {axios,instance} from './api/axios';
import App from './App'
import print from './assets/js/print'
import myplugin from './assets/js/myplugin'

Vue.prototype.axios = axios;
Vue.prototype.ajax = instance;
Vue.prototype.$echarts = echarts;
Vue.use(permission);
Vue.use(ElementUI);
Vue.use(print);
Vue.use(myplugin);
Vue.use(BaiduMap,{
  ak:'j6ox4KUfzAejvBGcAazAcE6SkNV2hFgB'
});


Vue.config.productionTip = false;



Vue.prototype.testurl="";

let vueModel = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted(){
    this.$router.push("/index");
  }
});




// WEBPACK FOOTER //
// ./src/main.js